import { WithAuthorization } from "../../context";
import { Center, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import React, { useState } from "react";
import { Page } from "../../components/Page";
import { Card } from "../../components/Card";
import { useTranslation } from "react-i18next";
import { SupplierCategories } from "./components";

function SupplierSettings() {
  const { t } = useTranslation("translation", {
    keyPrefix: "supplierSettings"
  });
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Page title={t("page.title")} subTitle={t("page.subTitle")}>
      <Card>
        <Tabs colorScheme="customScheme" index={tabIndex} onChange={setTabIndex} isLazy>
          <Center>
            <TabList borderBottom="none" marginBottom={4}>
              <Tab _focus={{ boxShadow: "none" }}>{t("tabs.supplierCategories")}</Tab>
            </TabList>
          </Center>
          <TabPanels>
            <TabPanel padding="0">
              <SupplierCategories />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Card>
    </Page>
  )
}

export default WithAuthorization(SupplierSettings);